<template>
  <div class="wrapper">
    <Header
      name="Vos espaces"
      :buttons="[
        {
          class: 'primary sm icon-left icon',
          label: 'Créer un espace',
          icon: 'bi-plus-lg',
          click: () => {
            state.modalIsOpen = true;
            state.modalAction = 'create';
          },
        },
      ]"
    />
    <transition name="fade">
      <div class="spaces-wrapper" v-if="companySpaces?.length > 0">
        <div
          class="card"
          v-for="(space, index) in [...companySpaces].sort((a, b) =>
            a.name.localeCompare(b.name)
          )"
          :key="space.id"
        >
          <div class="header">
            <img
              :src="
                space.image_id
                  ? getImage(space.image_id)
                  : getRandomSpacePicture(space.name)
              "
              alt="Logo"
            />
            <div class="btn-group">
              <Button
                class="icon round secondary"
                icon="bi-gear"
                @click="
                  () => {
                    state.modalIsOpen = true;
                    state.space = space;
                    state.modalAction = 'edit';
                  }
                "
              />
            </div>
          </div>
          <div class="space-number">Espace {{ index + 1 }}</div>
          <div class="space-name" v-text="space.name" />
          <div class="stats">
            <div class="stat">
              <span
                class="number"
                v-text="
                  state.campaignsLoad
                    ? '...'
                    : getNumberOfCampaigns(space.workspace_id)
                "
              />
              Campagnes
            </div>
          </div>
          <Button
            class="sm primary icon-left icon"
            label="Voir plus"
            icon="bi-arrow-right"
            @click="
              $router.push({
                name: 'space',
                params: { spaceId: space.workspace_id },
              })
            "
          />
        </div>
      </div>
    </transition>
    <SpaceModal
      :isOpen="state.modalIsOpen"
      :space="state.space"
      :action="state.modalAction"
      @close="(state.modalIsOpen = false), (state.space = null)"
    />
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { reactive, watch } from "vue";
import { useRoute } from "vue-router";
import { useSpaceStore } from "@/stores/space.js";
import { useCampaignStore } from "@/stores/campaign.js";
import { getImage, getRandomSpacePicture } from "@/composables/getImage.js";
import Header from "@/components/Header.vue";
import SpaceModal from "@/components/modals/app/SpaceModal.vue";

const spaceStore = useSpaceStore();

const campaignStore = useCampaignStore();

const { campaigns } = storeToRefs(campaignStore);

const { companySpaces } = storeToRefs(spaceStore);

const route = useRoute();

const state = reactive({
  modalAction: "",
  modalIsOpen: false,
  space: null,
  campaignsLoad: true,
  stats: [],
});

function getNumberOfCampaigns(space_id) {
  const spaceCampaigns = campaigns.value.filter(
    (campaign) => campaign.workspace_id === space_id && !campaign.archived
  );

  return spaceCampaigns?.length;
}

watch(
  companySpaces,
  async () => {
    if (companySpaces.value?.length) {
      const promises = [];

      companySpaces.value.forEach((space) => {
        const promise = async () => {
          await campaignStore.getCampaigns(
            route.params.companyId,
            space.workspace_id
          );

          space.fetchedCampaigns = true;
        };

        if (!space.fetchedCampaigns) {
          promises.push(promise);
        }
      });

      await Promise.all(promises.map((asyncFn) => asyncFn()));

      state.campaignsLoad = false;
    }
  },
  { immediate: true }
);
</script>
